import { ThemePresentation } from '@lsg/shared';
import { createElement } from 'react';

/** @deprecated */

var Looks;

(function (Looks) {
  Looks["DARK"] = "dark";
  Looks["ELEVATED"] = "elevated";
  Looks["LIGHT"] = "light";
  Looks["DEFAULT"] = "light";
})(Looks || (Looks = {}));

var defaultProps = {
  look: "dark"
};

var Theme = function Theme(props) {
  return /*#__PURE__*/createElement(ThemePresentation, Object.assign({}, props));
};

Theme.defaultProps = defaultProps;
Theme.Looks = Looks;
Theme.displayName = "Theme";

export { Looks, Theme };
